<template>
<div id="DeviceDetail">
    <div class="desc-container">
        <div class="detail-title">
            <div class="title-area">
                {{$t(/*设备UID*/'device.device_uid')}}：{{detail.uid}}
                <div class="sub status status-bg" :class="detail.status ? 'blue' : 'red'">{{$t($U.deviceStatusFilter(detail))}}</div>
            </div>
        </div>
        <el-row class="detail-desc">
            <el-col :span="12" class="desc-item">
                <div class="key">{{$t(/*设备类型*/'device.device_space')}}：</div>
                <div class="value">{{$t($U.deviceSpaceFilter(detail.space))}}</div>
            </el-col>
            <el-col :span="12" class="desc-item">
                <div class="key">{{$t(/*经纬度*/'c.coordinate')}}：</div>
                <div class="value">{{detail.longitude || '-'}}, {{detail.latitude || '-'}}</div>
            </el-col>
            <el-col :span="12" class="desc-item">
                <div class="key">{{$t(/*创建时间*/'c.create_time')}}：</div>
                <div class="value">{{$U.timeFormat(detail.create_time || detail.createTime)}}</div>
            </el-col>
            <el-col :span="12" class="desc-item">
                <div class="key">{{$t(/*最后活动时间*/'device.last_active_time')}}：</div>
                <div class="value">{{$U.timeFormat(detail.last_active_time || detail.lastActiveTime)}}</div>
            </el-col>
        </el-row>
    </div>
    <el-tabs v-model="activeTab" class="tab-container" type="card">
        <el-tab-pane :label="$t(/*设备信息*/'device.DeviceInfo')" name="DeviceInfo">
            <BatteryInfo :uid="uid" :id="detail.id" :detail='detail' :space="space" v-if="activeTab === 'DeviceInfo'"/>
        </el-tab-pane>
        <el-tab-pane :label="$t(/*设备事件*/'device.EventList')" name="EventList">
            <EventList :uid="uid" :id="detail.id" :detail='detail' :space="space" v-if="activeTab === 'EventList'"/>
        </el-tab-pane>
        <el-tab-pane :label="$t(/*上行数据*/'device.FrameList')" name="FrameList">
            <FrameList :uid="uid" :id="detail.id" :detail='detail' :space="space" v-if="activeTab === 'FrameList'"/>
        </el-tab-pane>
        <el-tab-pane :label="$t(/*下行命令*/'device.CommandList')" name="CommandList">
            <CommandList :uid="uid" :id="detail.id" :detail='detail' :space="space" v-if="activeTab === 'CommandList'"/>
        </el-tab-pane>
        <el-tab-pane :label="$t(/*推送记录*/'device.RelayLog')" name="RelayLog">
            <RelayLog :uid="uid" :id="detail.id" :detail='detail' :space="space" v-if="activeTab === 'RelayLog'"/>
        </el-tab-pane>
        <el-tab-pane :label="$t(/*操作*/'c.operation')" name="CmdOperation">
            <CmdOperation :uid="uid" :id="detail.id" :detail='detail' :space="space" v-if="activeTab === 'CmdOperation'"/>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script type="text/ecmascript-6">
import Core from '../../core'

export default {
    name: "DeviceDetail",
    components: {
        BatteryInfo: () => import('./components/BatteryInfo.vue'),
        EventList: () => import('./components/EventList.vue'),
        FrameList: () => import('./components/FrameList.vue'),
        CommandList: () => import('./components/CommandList.vue'),
        RelayLog: () => import('./components/RelayLog.vue'),
        CmdOperation: () => import('./components/CmdOperation.vue'),
    },
    data() {
        return {
            userType: Core.Data.getUserType(),

            space: '',

            uid: '',
            detail: {},

            activeTab: '',
        }
    },
    watch: {
        $route: {
            deep: true,
            immediate: true,
            handler(newRoute) {
                this.space = newRoute.meta.space
            }
        }
    },
    mounted() {
        this.uid = this.$route.query.uid;
        this.getDeviceDetail()
    },
    methods: {
        getDeviceDetail() {
            let apiName = this.$auth('ADMIN') ? 'detail' : 'detailByUid'
            Core.Api.Battery[apiName]({
                uid: this.uid,
                space: this.space,
            }).then(res => {
                console.log('getBatteryDetail res:', res)
                this.detail = res.battery;
                this.activeTab = 'DeviceInfo'
            })
        }
    }
}
</script>

<style scoped lang="scss">
// #DeviceDetail {}
</style>
